import { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import styleServIns from "../../styles/inputGrid.module.css";
import { GetInsumos } from "../../actions/Insumo";
import Servins from "../../actions/Servins";
import { formatos } from "../../actions/formats.jsx";
const FormCompra = () => {
   const { formatoNumero } = formatos();
   const location = useLocation();
   const navigate = useNavigate();
   const { state } = location;
   const token = localStorage.getItem("token");
   const urlSI = process.env.REACT_APP_URL_DIR + "servins";

   const [input, setInput] = useState({
      id_primary: state ? state.id_primary : 0,
      id: state ? state.id : "",
      desc: state ? state.desc : "",
      cantidad: 0,
      servicioIdPrimary: 0,
      insumoIdPrimary: 0,
      servicio: state ? state.servicio : 0,
      tipo: state ? state.tipo : 0,
      servData: [],
   });

   const [isInitialized, setIsInitialized] = useState(false);
   const [inputValues, setInputValues] = useState({}); // ✅ Estado separado para valores de inputs
   const inputRefs = useRef({});

   const insumos = GetInsumos();
   const servins = Servins(state?.id_primary);

   // ✅ useEffect para cargar servData inicial
   useEffect(() => {
      if (insumos && servins && servins.length > 0 && !isInitialized) {
         clearServData()
         console.log("Cargando servData inicial:", servins);

         const newServData = servins.map((item) => ({
            id_primary: item.insumoIdPrimary,
            id: item.servicioIdPrimary,
            descripcion: item.insumo.descripcion,
            dolar: item.insumo.dolar,
            stock: item.insumo.stock,
            cantidad: item.cantidad,
         }));

         // Ordenar por descripción
         newServData.sort((a, b) => {
            const nameA = a.descripcion.toUpperCase();
            const nameB = b.descripcion.toUpperCase();
            return nameA.localeCompare(nameB);
         });

         console.log("Estableciendo newServData:", newServData);

         // ✅ Actualizar tanto servData como inputValues
         setInput((prevInput) => ({
            ...prevInput,
            servData: newServData,
         }));

         // ✅ Inicializar valores de inputs
         const initialInputValues = {};
         newServData.forEach(item => {
            initialInputValues[item.id_primary] = item.cantidad;
         });
         setInputValues(initialInputValues);

         setIsInitialized(true);
      }
   }, [insumos, servins, isInitialized]);

   // ✅ Generar productosFiltrado
   const productosFiltrado = [];
   if (insumos && Array.isArray(insumos)) {
      for (let i = 0; i < insumos.length; i++) {
         const newProdmp = {
            id_primary: insumos[i].id_primary,
            descripcion: insumos[i].descripcion,
            dolar: insumos[i].dolar,
            stock: insumos[i].stock,
            cantidad: 0,
         };
         if (
            (insumos[i].tipo !== 2 && input.tipo !== 2) ||
            (insumos[i].tipo > 1 && input.tipo === 2)
         ) {
            productosFiltrado.push(newProdmp);
         }
      }
   }

   // Calcular total
   const totins = input.servData.reduce(
      (sum, serv) => sum + serv.cantidad * serv.dolar,
      0
   );

   // ✅ Función para limpiar manualmente servData
   const clearServData = async () => {
      console.log("Input actual:", input);
      setInput((prevInput) => ({
         ...prevInput,
         servData: [],
      }));
      setInputValues({}); // ✅ Limpiar también los valores de inputs
      setIsInitialized(false);
      console.log("Input FINAL:", input);
   };

   const handleSubmit = (e) => {
      e.preventDefault();
      console.log("handleSubmit: ", input.servData);

      if (input.servData.length > 0) {
         fetch(urlSI + "/" + input.servData[0].id + "/insumos", {
            method: "POST",
            body: JSON.stringify(input.servData),
            headers: {
               Authorization: `Bearer ${token}`,
               "Content-Type": "application/json",
            },
         })
            .then((res) => res.json())
            .then(() => {
               console.log("Datos guardados exitosamente");
               clearServData(); // ✅ Limpiar después de guardar
               navigate("/Servicio");
            })
            .catch((error) => {
               console.error("Error:", error);
            });
      }
   };

   // ✅ Función para actualizar valores de input
   const handleInputChange = (codprv, value) => {
      setInputValues(prev => ({
         ...prev,
         [codprv]: value
      }));
   };

   // ✅ Función helper para actualizar servData
   function updateServData(cantidad, codprv) {
      console.log(`Actualizando cantidad: ${cantidad} para producto: ${codprv}`);
      
      setInput((prevInput) => {
         const newServData = [...prevInput.servData];
         const existingIndex = newServData.findIndex(
            (item) => item.id_primary === codprv
         );

         if (existingIndex >= 0) {
            if (cantidad > 0) {
               newServData[existingIndex] = {
                  ...newServData[existingIndex],
                  cantidad: cantidad,
               };
               console.log(`Actualizado item existente:`, newServData[existingIndex]);
            } else {
               console.log(`Eliminando item:`, newServData[existingIndex]);
               newServData.splice(existingIndex, 1);
            }
         } else if (cantidad > 0) {
            const insumo = insumos.find((ins) => ins.id_primary === codprv);
            if (insumo) {
               const newItem = {
                  id_primary: insumo.id_primary,
                  id: prevInput.id,
                  descripcion: insumo.descripcion,
                  dolar: insumo.dolar,
                  stock: insumo.stock,
                  cantidad: cantidad,
               };
               newServData.push(newItem);
               console.log(`Agregado nuevo item:`, newItem);
               
               // Reordenar después de agregar
               newServData.sort((a, b) =>
                  a.descripcion
                     .toUpperCase()
                     .localeCompare(b.descripcion.toUpperCase())
               );
            }
         }

         console.log(`Nueva servData:`, newServData);
         return {
            ...prevInput,
            servData: newServData,
         };
      });
   }

   function handleCant(e, codprv) {
      if (e.key === "Enter") {
         const cantidad = parseFloat(e.target.value) || 0;
         console.log(`Enter presionado - cantidad: ${cantidad}, producto: ${codprv}`);
         updateServData(cantidad, codprv);
      }
   }

   function handleCant2(e, codprv) {
      const cantidad = parseFloat(e.target.value) || 0;
      console.log(`Blur evento - cantidad: ${cantidad}, producto: ${codprv}`);
      updateServData(cantidad, codprv);
   }

   // Loading states
   if (!insumos) {
      return <div>Cargando Insumos...</div>;
   }

   console.log("=== RENDER ===");
   console.log("Current servData:", input.servData);
   console.log("Current inputValues:", inputValues);
   console.log("isInitialized:", isInitialized);

   return (
      <>
         <div className={styleServIns.container}>
            <div className={styleServIns.trTitle}>
               <h2>{input.desc}</h2>
            </div>
            
            {/* Debug info 
            <div style={{ background: "#f0f0f0", padding: "10px", margin: "10px 0", fontSize: "12px" }}>
               <strong>Debug:</strong> servData items: {input.servData.length} | 
               isInitialized: {isInitialized.toString()} |
               Total: ${totins.toFixed(2)} |
               InputValues: {Object.keys(inputValues).length}
            </div>
               */}

            <div style={{ marginBottom: "10px", textAlign: "right" }}>
               <button
                  className={styleServIns.inputBtnNew}
                  onClick={clearServData}
                  style={{ backgroundColor: "#dc3545", color: "white" }}
               >
                  🗑️ Limpiar Todo
               </button>
            </div>

            <div className={styleServIns.gridTableBack}>
               <div className={styleServIns.trTitle}>Insumos / Servicios</div>
               <div className={styleServIns.divflex}>
                  <div className={styleServIns.divIzq}>
                     <table className={styleServIns.gridTable}>
                        <thead>
                           <tr className={styleServIns.trTitle}>
                              <th>Descripcion</th>
                              <th>Precio</th>
                              <th>Cantidad</th>
                           </tr>
                        </thead>
                        <tbody>
                           {productosFiltrado.map((serv) => {
                              return (
                                 <tr key={serv.id_primary}>
                                    <td className={styleServIns.tdleft}>
                                       &nbsp;{serv.descripcion}
                                    </td>
                                    <td className={styleServIns.precio}>
                                       {formatoNumero(serv.dolar)}
                                    </td>
                                    <td className={styleServIns.tdright}>
                                       &nbsp;&nbsp;&nbsp;
                                       <input
                                          ref={(el) =>
                                             (inputRefs.current[serv.id_primary] = el)
                                          }
                                          className={styleServIns.style_input}
                                          type="number"
                                          step="0.01"
                                          min="0"
                                          value={inputValues[serv.id_primary] || ""} // ✅ Usar value controlado
                                          onChange={(e) => handleInputChange(serv.id_primary, e.target.value)} // ✅ Manejar cambios
                                          onBlur={(e) => handleCant2(e, serv.id_primary)}
                                          onKeyPress={(e) => handleCant(e, serv.id_primary)}
                                       />
                                    </td>
                                 </tr>
                              );
                           })}
                        </tbody>
                     </table>
                  </div>

                  <div className={styleServIns.divright}>
                     <table className={styleServIns.gridTable}>
                        <thead>
                           <tr className={styleServIns.trTitle}>
                              <th>Descripcion</th>
                              <th>Cantidad</th>
                              <th>Total</th>
                           </tr>
                        </thead>
                        <tbody>
                           {input.servData.map((serv, indx) => (
                              <tr key={`${serv.id_primary}-${indx}`}>
                                 <td className={styleServIns.tdleft}>
                                    &nbsp;{serv.descripcion}
                                 </td>
                                 <td className={styleServIns.precio}>
                                    &nbsp;&nbsp;&nbsp;{serv.cantidad}&nbsp;
                                 </td>
                                 <td className={styleServIns.precio}>
                                    &nbsp;&nbsp;&nbsp;
                                    {(serv.cantidad * serv.dolar).toFixed(2)}
                                    &nbsp;
                                 </td>
                              </tr>
                           ))}
                           <tr>
                              <td>&nbsp;</td>
                              <td>Total</td>
                              <td className={styleServIns.precio}>
                                 {totins.toFixed(2)}&nbsp;
                              </td>
                           </tr>
                           <tr>
                              <td>
                                 <button
                                    className={styleServIns.inputBtnNew}
                                    onClick={handleSubmit}
                                 >
                                    Grabar
                                 </button>
                              </td>
                              <td>&nbsp;</td>
                              <td>
                                 <button
                                    className={styleServIns.inputBtnNew}
                                    onClick={() => navigate("/Servicio")}
                                 >
                                    VOLVER
                                 </button>
                              </td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
               </div>
            </div>
            <br />
            <div>
               <button
                  className={styleServIns.inputBtnNew}
                  onClick={handleSubmit}
               >
                  Grabar
               </button>
               &nbsp;&nbsp;&nbsp;&nbsp;
               <button
                  className={styleServIns.inputBtnNew}
                  onClick={() => navigate("/Servicio")}
               >
                  VOLVER
               </button>
            </div>
         </div>
      </>
   );
};

export default FormCompra;